import cn from 'classnames';

type ProductPriceRangeProps = {
    className?: string;
    fromPrice: string;
    isOnSale?: boolean;
    toPrice: string;
};

export function ProductPriceRange({
    className,
    fromPrice,
    isOnSale = false,
    toPrice,
}: Readonly<ProductPriceRangeProps>) {
    const priceLabel = isOnSale ? 'Sale price' : 'Price';

    return (
        <div className={cn('sparky-c-price', className)}>
            <span className="visually-hidden">
                {priceLabel} range is {fromPrice} to {toPrice}
            </span>
            <span aria-hidden="true" className={isOnSale ? 'sparky-c-price--sale' : 'sparky-c-price'}>
                {fromPrice} - {toPrice}
            </span>
        </div>
    );
}
